export function initGalleries() {

    let galleries = document.querySelectorAll('[data-gallery]');
    Array.from(galleries).forEach((gallery) => {
        let close = gallery.querySelector('[data-gallery-close]');
        close.addEventListener('click', () => {
            gallery.removeAttribute('data-gallery-open');
        });
    });

}

export default initGalleries;